import { render, staticRenderFns } from "./pay-user-sg.vue?vue&type=template&id=aecf99ae&scoped=true"
import script from "./pay-user-sg.vue?vue&type=script&lang=js"
export * from "./pay-user-sg.vue?vue&type=script&lang=js"
import style0 from "./pay-user-sg.vue?vue&type=style&index=0&id=aecf99ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecf99ae",
  null
  
)

export default component.exports